export enum SearchType {
  WORK = 0, // 検査ごと
  HOUR = 1, // 1時間ごと
  DAY = 2, // 1日ごと
  MONTH = 3 // 1ヶ月ごと
}

export interface SearchConditions {
  selectDateFrom: string;
  selectDateTo: string;
  work: string[];
  deviceid: string[];
  judge: number;
  searchType: SearchType;
}

export interface MachingTrendData {
  uuid: string;
  lq_time: string;
  job_type: number;
  map: string;
  branch_no: number;
  upper_distance: number;
  lower_distance: number;
  upper_limit: number;
  lower_limit: number;
  year_month: string;
  year_month_day: string;
  year_month_day_hour: string;
  total_judge: number;
  serial: string;
  idx: number;
}

export interface GraphBaseData {
  data_upper_distance: Array<number[] | number>;
  data_lower_distance: Array<number[] | number>;
  data_upper_limits: Array<number[] | number>;
  data_lower_limits: Array<number[] | number>;
  upper_distance_min: number;
  upper_distance_max: number;
  lower_distance_min: number;
  lower_distance_max: number;
  limits_min: number;
  limits_max: number;
  hasMultipleLimit: boolean;
  xlist: string[];
  detail: Array<MachingTrendData>;
  map: string;
}

export interface GraphSelectedData {
  mapName: string;
}
